export const submitPmaOnb = (instance, data) => {
  return instance({ showErrorsAlways: true })
    .post(`/onboarding/api/v1/submit/`, data)
    .then((response) => {
      return { data: response?.data, error: response?.response?.data };
    });
};

export const startPmaOnb = (instance, data) => {
  return instance()
    .post(`/onboarding/api/v1/start/`, data)
    .then((response) => {
      return response;
    });
};

export const onboardingLanding = (instance, onbId, data) => {
  return instance({ showErrorsAlways: true })
    .post(`/onboarding/api/v1/landing/${onbId}/`, data)
    .then((response) => {
      return response;
    });
};

export const onboardingTerminal = (instance, onbId) => {
  return instance()
    .get(`/onboarding/api/v1/terminal/${onbId}/`)
    .then((response) => {
      return response?.data;
    });
};

export const callback = (instance, onbId, transactionUuid) => {
  return instance()
    .get(`/onboarding/api/v1/callback/${onbId}/${transactionUuid}/`)
    .then((response) => {
      return response?.data;
    });
};

export const getPmaByPlanId = (instance, planId) => {
  return instance()
    .get(`/onboarding/api/v1/onb/pma/${planId}/`)
    .then((response) => {
      return response?.data;
    });
};

export const postPmaOtpSend = (instance, pmaUuid, data) => {
  return instance({ showErrorsAlways: true })
    .post(`/onboarding/api/v1/pma-onb/otp/send/${pmaUuid}/`, data)
    .then((response) => {
      return response;
    });
};

export const getPmaContracts = (instance, pmaUuid) => {
  return instance()
    .get(`/onboarding/api/v1/pma-onb/${pmaUuid}/contracts/`)
    .then((response) => {
      return response?.data;
    });
};

export const getPmaDownloadContract = (instance, { pmaUuid, contractKey }) => {
  return instance({ showErrorsAlways: true })
    .get(`/onboarding/api/v1/pma-onb/download/${pmaUuid}/${contractKey}/`, {
      responseType: "blob",
    })
    .then((response) => {
      return response?.data;
    });
};
